export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-slider-bar/index.js